export default __webpack_public_path__ + "static/media/ic_al_kuppiya.8cbe04a9.jpg";